import { ConfirmationDialogData } from './confirmation-dialog/confirmation-dialog.component';
import { DialogService } from './dialog.service';

/**
 * DecoratorFactory de méthode permettant d'afficher une modale de confirmation
 * @param data ConfirmationDialogData optionnel pour définir les éléments de la modale
 */
export function WithConfirmationDialog(
    data?: Pick<
        ConfirmationDialogData,
        | 'titre'
        | 'messageTexte'
        | 'messageHtml'
        | 'type'
        | 'cancelButtonLabel'
        | 'confirmButtonLabel'
        | 'cancelButtonIcon'
        | 'confirmButtonIcon'
    >
): MethodDecorator {
    return function(target: object, propertyKey: string | symbol, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = async function(...args: unknown[]) {
            let newData: ConfirmationDialogData = {
                ...data,
                messageTexte: data?.messageTexte?.map((message: string | ((args) => string)) =>
                    typeof message === 'string' ? message : message(args)
                ),
                messageHtml: data?.messageHtml?.map((html: string | ((args) => string)) => (typeof html === 'string' ? html : html(args)))
            };
            if (data?.type !== undefined) {
                newData = {
                    ...newData,
                    type: typeof data?.type === 'string' ? data?.type : data?.type(args)
                };
            }
            DialogService.instance?.openConfirmationDialog(newData).subscribe((confirmation?: boolean) => {
                if (confirmation) {
                    originalMethod.apply(this, args);
                }
            });
        };
        return descriptor;
    };
}
